import type { FC } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { SvgIconType } from '@thermenresorts/icons';
import type ApiBathCardUsps from 'src/core/models/api/ApiBathCardUsps';
import Colors from 'src/core/utils/Colors';
import Dimens from 'src/core/utils/Dimens';
import Fonts from 'src/core/utils/Fonts';
import Styles from 'src/core/utils/Styles';
import Translations from 'src/core/utils/Translations';
import SvgIcon from 'src/presentation/components/atoms/SvgIcon';
import { HtmlView } from 'src/presentation/components/organisms/HtmlView';

interface Props {
	usps: ApiBathCardUsps | null;
}

const BathCardUspsCard: FC<Props> = ({ usps }) => {
	const items = (usps?.items ?? []).filter((item) => item.text !== null && item.text !== '');

	if (usps === null || !usps.show || items.length === 0) {
		return null;
	}

	return (
		<View style={[styles.card, Styles.card.shadowSoft]}>
			<Text style={styles.title}>{usps.title ?? Translations.bathcardUspsTitle}</Text>

			{/* Wraps the rows so the card gap stays between the title and the list, not between the rows. */}
			<View>
				{items.map((item) => (
					<View key={item.id} style={styles.row}>
						<SvgIcon
							name={SvgIconType.checkmarkCircle}
							size={Dimens.iconSize20}
							style={styles.icon}
							tintColor={Colors.green700}
						/>
						<HtmlView html={item.text ?? ''} style={styles.text} />
					</View>
				))}
			</View>
		</View>
	);
};

const styles = StyleSheet.create({
	card: {
		backgroundColor: Colors.white,
		borderRadius: Dimens.borderRadius4,
		padding: Dimens.padding20,
		gap: Dimens.gap16,
	},
	title: {
		color: Colors.gray900,
		fontFamily: Fonts.ptSerif,
		fontSize: Dimens.fontSize18,
		lineHeight: Dimens.lineHeight24,
	},
	row: {
		flexDirection: 'row',
		alignItems: 'flex-start',
		gap: Dimens.gap12,
	},
	// Nudges the 20px icon onto the optical centre of the first line, which runs on a 24px line box.
	icon: {
		marginTop: Dimens.padding3,
	},
	text: {
		flex: Dimens.flex1,
	},
});

export default BathCardUspsCard;
